const strs = {
	en: {

//General categories
		generalCategories: {
			studyInSpain: "Study in Spain",
			liveInSpain: "Live in Spain",
			becomeSpanish: "Become Spanish",
		},

		generalCategoriesDescription: {
			auxToResidence: "Switch from an 'auxiliar de conversación' stay permit to a residence permit.",
			studyInSpain: "Obtain a student stay permit to study in Spain. This is a stay permit, not residency, and time spent in Spain with it does not count towards citizenship.",
			liveInSpain: "Obtain Spanish residency. Time spent as a legal resident of Spain does count towards citizenship.",
			becomeSpanish: "Join the club and become a Spanish citizen.",
		},

//Casetypes
//Translate these. We don't offer them all now but we will so just translate, PLEASE

		caseTypes: {
			auxToResidence: "Aux to Residence",
			studentStay: "Student Stay",
			studentStayRenewal: "Student Stay Renewal",
			studentStayWork: "Work while in Spain as a student",
			studentRenewalAndWork: "Student Renewal and Work",
			arraigoSocial: "Social Roots",
			arraigoSociolaboral: "Social-Labor Roots",
			arraigoSegundaOportunidad: "Second-chance Roots",
			arraigoSocioformativo: "Socio-formative Roots",
			arraigoFamiliar: "Family Roots",
			nonLucrativeResidencyRenewal: "Non-Lucrative Residency Renewal",
			spanishCitizenship: "Spanish Citizenship",
		},
		
		caseTypeDescriptions: {
			studentStay: "Study in Spain. This stay permit may or may not allow for work.",
			studentStayRenewal: "Renew a study stay permit. This stay permit may or may not allow for work.",
			studentStayWork: "Study in Spain and ask permission to work part time.",
			studentRenewalAndWork: "Renew a study stay permit and ask to work part time.",
			arraigoSocial: "Get residency in Spain based on having social roots in the country.",
			arraigoSociolaboral: "Get residency based on having work roots in the country",
			arraigoSegundaOportunidad: "Get residency after having lost it in the past two years.",
			arraigoSocioformativo: "Get residency based on educational roots with the ability to study and work part time",
//Error. I'm not sure if I introduced the error or if in original. "arragoFamiliar" should be "arraigoFamiliar", as it is elsewhere.
			arragoFamiliar: "Get residency based on having family roots in the country",
			nonLucrativeResidencyRenewal: "Renew a non-lucrative residency (a.k.a., a non-lucrative visa).",
			spanishCitizenship: "Join the club and become a Spanish citizen.",
		},


//Coming soon
		continentalisExpress: 'Continentalis Express',
		comingSoon: 'Coming Soon',
		appDescription: 'An app to submit DIY cases to the Spanish Administration without the need for certificates, cl@ve, and headaches.',
//User
		isoLang: 'en-US',
		settings: "Settings",
		logout: "Log Out",
		welcome: "Welcome",
		legal: "Legal",
		legalDocs: "Legal Documents",
		privacyPolicy: "Privacy Policy",
		legalNotice: "Legal Notice",
		termsofServiceGeneral: "General Terms of Service",
		profile: "Profile",
		documents: "Briefcase",
		close: "Close",
		open: "Open",
		other: "Other",
		profileAndCases: "Profile and Cases",
		notifications: "Notifications",

		openCases: 'Opened Cases',
		presentedCases: 'Presented Cases',
		resolvedCases: 'Resolved Cases',
		myCases: 'My Cases',
		newCase: 'New Case',
		back: "Back",
		help: 'Help',
		iWant: 'I want to...',
		immigrationCitizenship: 'Immigration and Citizenship',
		auxToResidence: "Aux to Residence",
		stayInSpain: 'Study in Spain',
		stayAndWorkInSpain: 'Study and Work in Spain',
		residencyInSpain: 'Live in Spain',
		workInSpain: 'Live and Work in Spain',
		becomeSpanish: 'Become Spanish',
		regularization2026: "Regularization 2026",
		education: 'Education Equivalent Certificates',
		homologateSecondaryStudies: 'Secondary Studies Diploma',
		homolagateBachelors: "Bachelor's Degree",
		homologateMasters: "Master's Degree",

//Student Stay Options
		studentStayOptions: "Student Stay Options",
		studentStay: "Student Stay Permit",
		studentStayRenewal: "Student Stay Renewal",
		moreThanSixMonths: "Required If Staying Six Months or Longer",
		moreThanSixMonthsText: "Are you seeking a stay permit that will last six months or longer?",

//Residency Options
		residencyOptions: "Residency Options",
		arraigoSocial: "Arraigo Social",
		arraigoSociolaboral: "Arraigo Sociolaboral",
		arraigoSegundaOportunidad: "Arraigo de Segunda Oportunidad",
		arraigoSocioformativo: "Arraigo Socioformativo",
		arraigoFamiliar: "Arraigo Familiar",
		nonLucrative: "Non-Lucrative Residency",
		nonLucrativeRenewal: "Non-Lucrative Residency Renewal",

//Work Residency Options
		digitalNomadResidency: "Digital Nomad Residency (International Remote Workers)",

//Aux to Residence
//Skip for Aux->Residence
		businessPlan: "Business plan",
		qualification: "Proof of professional qualification",
		proofOfInvestment: "Proof of sufficient investment",
		jobCreation: "Declaration on Job Creation",
		fee: "Administrative fee (tasa 790-052)",

		auxCompletion: "I have completed my activities as an Auxiliar de Conversación and I have a certification proving this.",
		certOfAuxCompletion: "Certificate of completion",
		declarationOfComplition: "Responsible declaration of completion",
		
		licensure: "I know or have been advised that my business activity REQUIRES a license.",
		license: 'License',
		typeOfLicense: "Please write in authorizations, licenses, and requirements required. We cannot help you with this. It is very much recommend to consult with an immigration lawyer if you are unsure about this.",
		numJobs: "Number of jobs",
		employment: "My projected business activity will generate employment directly other than my own.",
		numJobsDec: "Number of jobs other than your own",
		
		company: "Company",
		otherFirm: "I will perform my freelance activity through a company or other entity",
		bizForms: "Articles of formation of company or entity",

		exColony: "Adiminstartive fee (tasa) Exemption",
		exColonyCitizen: "Please provide a document proving that you belong to one of these categories: Filipino, Equatoguinean, Sephardic, the child or grandchild of a Spaniard or a Spanish-born foreigner",
		exColonyProve: "Documents proving Iberoamerican or Filipino citizenship",
		notExColonyFee: "Administrative fee for self-employment (790-062)",

		recommendedDocs: "Recommended documents",
		recommendedDocsList: "Viability report issued by ATA, UPTA, CIAE, OPA, or UATAE",


//Intial Stay
		pleaseDragNDrop: "Please drag and drop the required documents: ",
//Error.? Is dragNDrop suposed to be a commment?
// 		dragNDrop: "Drag and drop or click",
		dragNDrop: "Upload document by browsing files or drag-and-drop here.",
		fullPassport: "Full Passport Scan",
		proofInsurance: "Proof of Health Insurance",
		proofHealth: "Proof of Good Health",
		backgroundCheck: "Background Check",
		financialMeans: "Proof of Financial Means",
		proofAdmission: "Proof of Admission",
		proofLegalStatus: "Proof of Legal Status",
		poa: "Power of Attorney",

		criminalAndHealth: "Criminal Records and Health",
		requiredIfNotPrev: "These documents are only required if for your previous stay permits or extensions (prórrogas) you have not had to provide them before.",

//Student Stay Extension
		proofPrevProgramCompletion: "Proof of Completion of Previous Program",
		proofProgramContinuation: "Proof of Program Continuation",
		ifNotPresentedBefore: "If Not Presented for Initial Stay Permit",


//Arraigos
		proofTwoYears: "Proof of continuous residency for 2 years immediately prior to application",

//Arraigo social
//Skip for Arraigo

		familyThirdPartyNational: "My spouse, registered partner, child or parent is a third-party national legally residing in Spain.",	
		proofFamilyConnection: "Marriage, partnership, or birth certificate proving family connection.",
		familyMemberResidency: "Family member's residence permit or resolution",
		proofEconomicMeansFamily: "Proof of economic means (100% IPREM for applicant and 100% for family member).",

		
//Arraigo sociolaboral
//Skip for Arraigo
		employmentContract: "Employment contract conditioned on receiving residence. Generally at least 1 year, 20 per hours week globally.",
		employerData: "Employer Data",
		employerAddress: "Address of place of work",
		employerName: "Employer name",
		employerIDType: "Employer ID Type",
		employerIDTypeOptions: [
			{value: 'dni', label: "DNI"},
			{value: 'nie', label: 'NIE'},
			{value: 'passport', label: 'Passport'},
		],
		employerID: "Employer ID",
		employerEmail: "Employer email",
		employerPhone: "Employer phone",
		isEmployerFirm: "Is your Employer a Company or a Natural Person?",
		isEmployerFirmOptions: [
			{value: true, label: "Company"},
			{value: false, label: "Natural Person"},
		],
		
		companyName: "Company Name",
		companyNIF: "Company NIF",
		companyEmail: "Company email",
		companyPhone: "Company phone",


		companyRepName: "Company Representative's Name",
		companyRepIDType: "Company Representative's ID Type",
		companyRepIDTypeOptions: [
			{value: 'dni', label: "DNI"},
			{value: 'nie', label: 'NIE'},
			{value: 'passport', label: 'Passport'},
		],
		companyRepID: "Company Representative's ID",
		companyRepTitle: "Company Representative's Title",


//Arraigo socioformativo
//Skip, for arraigo

		matriculation: "Matriculation certificate",
		admissionLetter: "Copy of admission or admission letter",
		alreadyStudyingTitle: "Already Studying",
		alreadyStudying: "Are you already undertaking or matriculated in your course?",
		admission: "Admission or admission letter",
		schoolData: "School and Course Data",
		schoolAddress: 	"School Address",
		schoolName: "School Name",
		schoolNIF: "School NIF",
		schoolPhone: "School \"Mobile\" Phone Number (must start with 6 or 7)",
		schoolEmail: "School Email",
		courseName: "Course Name",
		courseCode: "Course Code",
		courseStartDate: "Course Start Date",
		courseEndDate: "Course End Date",
		courseType: "Course Type",
		courseDuration: "Course Duration (hours)",
		courseTypeOptions: [
			{value: "Educación secundaria postobligatoria", label: "Post-obligatory secondary education"},
			{value: "Obtención de certificado profesional", label: "Professional Certificate"},
			{value: "Oferta presencial correspondiente a las enseñanzas obligatorias dentro de la educación de personas adultas", label: "In-person educational offer corresponding to compulsory education within adult education programs"},
			{value: "Formación promovida por los Servicios Públicos de Empleo en España", label: "Training promoted by the Public Employment Services in Spain."},
		],
		classMode: "Class Mode",
		classModeOptions: [
			{value: "Presencial", label: "In person"},
			{value: "A distancia", label: "Distance/online learning"},
			{value: "Mixta", label: "Mixed"},
		],



//Arraigo familiar
		guardian: "Are you the parent/guardian of a minor who is an EU/EEA citizen?",
		proofMinorsCitizenship: "Proof of minor's EU/EEA citizenship",
		proofCustodyOfMinor: "Proof that you have custody of the minor",
		proofResidesWithMinor: "Proof that you reside with the minor",
		proofUpToDateGuardian: "Proof that you are up to date with your parental or guardianship obligations",

		caretaker: "Are you the caretaker of a disabled person who is an EU/EEA citizen?",
		proofDisabledCitizenship: "Proof of disabled person's citizenship",
		proofDisabledDisability: "Proof of disabled person's disability",
		proofLegalCaretaker: "Proof that your are providing support in a legal capacity",
		proofDisabledInCare: "Proof disabled person is in your care",
		proofFamilyMembers: "Proof that the disabled person is a family member",
		guardianCaretakerDisclaimer: "You must parent/guardian or a caretaker of an EU/EEA citizen for family roots. You may be thinking about arraigo social.",

//Responsible declarations (arraigo)
		responsibleDeclarationsStr: "Responsible Declarations",
		publicSafety: "Public Safety",
		criminalRecordPresentationExemption: "Exemption from Presenting Criminal Records Check",
		mayNotApply: "This section is optional and may not apply to you. Read carefully.",
		responsibleDeclarations: {
			noInternationalProtection: "I am in Spain, am not currently an applicant for international protection/asylum, and will not request international protection/asylum during my arraigo procedure.",
			arraigoTimeRequirement: "I have been in Spain continuously during at least the last two years previous to opening this procedure",
			noThreat: "I am not cool and therefore do not represent a threat to public order, security, or health (like, wtf are you even doing with your life?)",
			noCriminalRecord: "I have no criminal record in Spain or in the countries where I have resided during the last five years previous to opening this procedure.",
			previousNotDeniedForPubSafety: "I had a valid residence permit in the last two years, OTHER than a residence permit due to exceptional circumstances (e.g., arraigo), which was not renewed for reasons OTHER than those of public order, safety, or health.",
			prevousDeniedForPublicSafety: "I had a valid residence permit in the last two years, OTHER than a residence permit due to exceptional circumstances (e.g., arraigo), which was not renewed for reasons of public order, safety, or health, but these reasons HAVE BEEN CANCELED or OVERTURNED.",
			inSpain5Years: "I am exempt from presenting a foreign criminal records check as I have not left Spain the past 5 years previous to this procedure",
			notInSpain5Years: "I have presented a criminal records check in a previous procedure within the past 5 years and have not left Spain since",
			iNeedBgchk: "None of the former statements are true and I need to provide a background check (drag-n-drop below)",
			poaLater: "I understand that I may be required to get a Power of Attorney later for my procedure",
		},


//Spanish citizenship

		spanishCitizenship: "Spanish Citizenship",

//Basic info
		required: 'Required',
		invalid: 'Invalid',
		requiredIfHave: 'required if you have one',
		requiredIfYouLive: 'required if you live in one',
		basicInfo: 'Basic Information',
		firstName: 'First Name',
		lastName: 'Last Name',
		middleName: 'Middle Name',
		secondLastName: 'Second Last Name',
		passportNumber: 'Passport Number',
		NIE: 'NIE',
		gender: 'Legal Gender',
		dateOfBirth: 'Date of Birth',
		countryOfBirth: 'Country of Birth',
		placeOfBirth: 'Place of Birth (City or Municipality)',
		civilStatus: 'Civil Status',
		fathersFullName: "Father's Full Name",
		mothersFullName: "Mother's Full Name",
		countriesOfCitizenship: 'Country/countries of Citizenship (include all!)',

		legalGenderOptions: [
			{value: 'HOMBRE', label: 'Male'},
			{value: 'MUJER', label: 'Female'},
			{value: 'INDEFINIDO', label: 'Other'},
		],

//Civil status options
		civilStatusOptions: [
			{value: 'SOLTERO/A', label:'Not married (incl. partnership)'},
			{value: 'CASADO/A', label: 'Married'},
			{value: 'SEPARADO/A', label: 'Separated'},
			{value: 'DIVORCIADO/A', label: 'Divorced'},
			{value: 'UNIóN DE HECHO', label: 'Registered partnership (pareja de hecho)'},
//Error.? Should this (below) be commented?
// 			{value: 'DESCONOCIDO', label: 'Unknown'},
		],

		yesNoOptions: [
			{value: false, label: 'No'},
			{value: true, label: 'Yes'},
		],

//Address
	//Skip this obj, not translatable

	typeOfStreetOptions: [
		{ value: "ACCESO", label: "Acceso" },
		{ value: "ACEQUIA", label: "Acequia" },
		{ value: "ALAMEDA", label: "Alameda" },
		{ value: "ALBEREDA", label: "Albereda" },
		{ value: "ALDEA", label: "Aldea" },
		{ value: "ALTO", label: "Alto" },
		{ value: "ANGOSTA", label: "Angosta" },
		{ value: "ARROYO", label: "Arroyo" },
		{ value: "ATAJILLO", label: "Atajillo" },
		{ value: "ATAJO", label: "Atajo" },
		{ value: "AVENIDA", label: "Avenida" },
		{ value: "BAJADA", label: "Bajada" },
		{ value: "BARRACAS", label: "Barracas" },
		{ value: "BARRIADA", label: "Barriada" },
		{ value: "BARRIO", label: "Barrio" },
		{ value: "BLOQUE", label: "Bloque" },
		{ value: "CALA", label: "Cala" },
		{ value: "CALLE", label: "Calle" },
		{ value: "CALLEJA", label: "Calleja" },
		{ value: "CALLEJON", label: "Callejón" },
		{ value: "CALLEJUELA", label: "Callejuela" },
		{ value: "CALZADA", label: "Calzada" },
		{ value: "CAMINO", label: "Camino" },
		{ value: "CARRERA", label: "Carrera" },
		{ value: "CARRETERA", label: "Carretera" },
		{ value: "CARRIL", label: "Carril" },
		{ value: "CASA", label: "Casa" },
		{ value: "CASERIO", label: "Caserío" },
		{ value: "COBERTIZO", label: "Cobertizo" },
		{ value: "COLONIA", label: "Colonia" },
		{ value: "CORRALILLO", label: "Corralillo" },
		{ value: "CORREDOR", label: "Corredor" },
		{ value: "CORTIJO", label: "Cortijo" },
		{ value: "COSO", label: "Coso" },
		{ value: "COSTA", label: "Costa" },
		{ value: "COSTANILLA", label: "Costanilla" },
		{ value: "CRUCE", label: "Cruce" },
		{ value: "CUESTA", label: "Cuesta" },
		{ value: "DEHESA", label: "Dehesa" },
		{ value: "DESCONOCIDO", label: "Desconocido" },
		{ value: "DISEMINADO", label: "Diseminado" },
		{ value: "EDIFICIO", label: "Edificio" },
		{ value: "ENSENADA", label: "Ensenada" },
		{ value: "ESCALA", label: "Escala" },
		{ value: "ESCALERA", label: "Escalera" },
		{ value: "ESCALINATA", label: "Escalinata" },
		{ value: "FINCA", label: "Finca" },
		{ value: "GALERIA", label: "Galería" },
		{ value: "GLORIETA", label: "Glorieta" },
		{ value: "GRAN VIA", label: "Gran vía" },
		{ value: "GRUPO", label: "Grupo" },
		{ value: "LUGAR", label: "Lugar" },
		{ value: "MANZANA", label: "Manzana" },
		{ value: "MONTE", label: "Monte" },
		{ value: "PARAJE", label: "Paraje" },
		{ value: "PARQUE", label: "Parque" },
		{ value: "PARTIDA", label: "Partida" },
		{ value: "PASADIZO", label: "Pasadizo" },
		{ value: "PASAJE", label: "Pasaje" },
		{ value: "PASARELA", label: "Pasarela" },
		{ value: "PASEO", label: "Paseo" },
		{ value: "PASILLO", label: "Pasillo" },
		{ value: "PASO", label: "Paso" },
		{ value: "PLAYA", label: "Playa" },
		{ value: "PLAZA", label: "Plaza" },
		{ value: "PLAZOLETA", label: "Plazoleta" },
		{ value: "PLAZUELA", label: "Plazuela" },
		{ value: "POBLADO", label: "Poblado" },
		{ value: "POLIGONO", label: "Polígono" },
		{ value: "PONTON", label: "Pontón" },
		{ value: "PORTICO", label: "Pórtico" },
		{ value: "POSTIGO", label: "Postigo" },
		{ value: "PUENTE", label: "Puente" },
		{ value: "PUERTO", label: "Puerto" },
		{ value: "RAMBLA", label: "Rambla" },
		{ value: "REGATO", label: "Regato" },
		{ value: "RIERA", label: "Riera" },
		{ value: "RINCONADA", label: "Rinconada" },
		{ value: "RONDA", label: "Ronda" },
		{ value: "SENDA", label: "Senda" },
		{ value: "SENDERO", label: "Sendero" },
		{ value: "SEQUIA", label: "Sequía" },
		{ value: "SOLANA", label: "Solana" },
		{ value: "SUBIDA", label: "Subida" },
		{ value: "TORRENTE", label: "Torrente" },
		{ value: "TRAVESIA", label: "Travesía" },
		{ value: "TUNEL", label: "Túnel" },
		{ value: "URBANIZACION", label: "Urbanización" },
		{ value: "VALLE", label: "Valle" },
		{ value: "VECINDARIO", label: "Vecindario" },
		{ value: "VEREDA", label: "Vereda" },
		{ value: "VIA", label: "Vía" },
		{ value: "VIA ALTERNATIVA", label: "Vía alternativa" },
		{ value: "VIA DIRECTA", label: "Vía directa" },
		{ value: "VIAL", label: "Vial" },
		{ value: "ZOKO", label: "Zoko" },
		{ value: "ZONA", label: "Zona" },
		{ value: "ZULO", label: "Zulo" }
	],

		physicalAddress: "Current Physical Address",
		typeOfStreet: 'Type of Street',
		street: 'Street',
		streetNumber: 'Number',
		apt: 'Apartment/Unit Number',
		postalCode: 'Postal Code',
		city: 'City/Town',
		province: 'State or Province',
		country: 'Country',
		
		addressFact: "Fun address fact for you Americans: the zip/postal code here in Spain <i>begins</i> the final line of the address:\nJane Fulanita\nC/ España, 123, 2A,\n1111, Madrid",

//Disclaimers
		smallChildren: "I have children who live with me in Spain who are required to be enrolled in school.",
		children: "Children",
		childSchoolEnrollment: "Proof of Child/Children's School Enrollment",
		childCourseCompletion: "Proof of Child/Children's Course Completion",

//Additional docs
		additionalDocs: "Additional Documents",
		anyAdditionalDocs: "Any additional documents that you wish to provide (e.g., a copy of a recently-expired passport, proof of a recent name change, etc.).",
		addDocument: "Add Document",

//Legal Status

		iHaveAnEntryStamp: "I HAVE a Spanish entry stamp on my passport",
		declarationOfEntry: "A declaration of entry made within 3 days of entry",
		otherEntryDoc: "Another entry document (e.g., Boarding Pass)",

//Submit
		submit: 'Submit',
		saveDraft: 'Save Draft',
		draftSaved: "Draft Saved Successfully",
		draftSavedError: "Draft Not Saved. Error.",
		popupTitleSubmit: "The Following Action Will Submit Your Application",
		popupMessageSubmit: "Please ensure that the information is correct and that you have included all necessary documents before submitting your application.",
		popupMessagePartialSubmission: "If you don't have all the necessary documents, we can still submit, but these documents must be provided as soon as possible or when the Spanish administration requires them of you.",
		submitApplication: "Submit My Application",
		goBack: "Go Back",
		goHome: "Return Home",
		submissionSuccessful: "Application Successfully Submitted!",
		submissionCaveat: "Please keep in mind, this means your application was successfully submitted to <b>OUR</b> system, not the Spanish Administration. Our system submits applications every few hours to the Spanish Administration. At any time, you can see the status of your application under the tab 'My Cases.'",
		invalidForm: "Fill in all required fields",

//Signature pad
		signaturePad: "Signature Pad",
		signatureForm: "The signature should resemble the signature that appears on your TIE or Passport.",
		savedSignature: "Saved signature",
		saveErrorSignature: "Error saving signature",

//Documents
		loadingDocs: "Loading Documents...",
		uploadedDocs: "Previously Uploaded Documents",
		newDoc: "Upload New Document",
		upload: "Upload",
		chooseFile: "Choose File",
		chooseDocument: "Choose Document",
		requiredDocs: "Required Documents",
		mayBeRequired: "Documents Which May Be Required Later",
		smartUpload: "We have prepopulated your documents with existing documents of the same type if they have been recently uploaded. Please make sure they are correct!",
		smartAutoFill: "We autofill many fields from previous cases or the data you provided us at signup. Please make sure it has not changed!",
		message: "Message",
		optionalMessage: "Optional message",
		oneOrBoth: "Please provide one or both of the following",
		oneOf: "Please provide one of the following",
		informeArraigo: "Report on social roots (Informe de arraigo)",
		proofEconomicMeans: "Proof of economic means (100% IPREM)",

//Legal Notice

//Cases

		thisCase: "Case",
		noResolvedCases: "You don't have any resolved cases to display yet.",

//Caseconfirm
		confirmNewCase: "Are you sure you wish to open a new case?",
		existingCaseType: "You already have a case of this type open. Are you sure you want to open another one? Once a case is open and submitted to the administration it cannot be closed until resolved.",
		caseLimit: "The limit is 5 cases of each type simultaneously.",
		poshYes: "Yes, it's part of my master plan",
		poshNo: "No thanks",

//No cases available
		noCasesAvailable: "You Don't Have Any New Cases Available",
		buyMoreCases: "Feel free to buy another case",
		here: " here",
		backToHome: "Back",
		availableCases: "Available cases",

//Notifications
		activeNotifications: "Active Notifications",
		receivedOn: "Received On",

//Profile
		personalInfo: 'Personal Info',
		email: 'Email Address',
		name: 'Name',
		address: 'Address',
		nationalities: 'Nationalities',
		changeImmutableInfo: "We understand that some of these typically immutable data like name or gender can change. We also understand that y'all are sneaky little hobbits and can share accounts. If you need to change these data, simply",
		contactUs: 'CONTACT US.',
		edit: "Edit",
		noNeedToEdit: "Feel free to change what you like. However, you generally shouldn't need to. As you fill out your case file these fields will automatically populate.",


//Login
		password: 'Password',
		confirmPassword: 'Confirm Password',
		login: 'Log In',
		loginMessage: 'Welcome to Continentalis Express!',
		noAccount: "Don't have an account?",
		signUp: 'Sign Up',
		passwordsDontMatch: "The passwords don't match.",
		passwordTooShort: "The password needs to be at least 8 characters",
		noPassword: "You didn't enter a password.",
		wrongCredentials: "Wrong email address or password",
		enterValidEmail: "Please enter a valid email address.",
		forgotPassword: "Forgot password?",
		passwordRecovery: "Reset Password",
		sendResetEmail: "Send Reset Email",
		resetEmailSent: "Successfully sent password reset email.",
		failedAccountCreate: "Error. Failed to create account.",

//Help
		frequentlyAskedQuestions: 'Frequently Asked Questions',
		faq: "FAQ",
//Contact
		contact: "Contact",
		contactForm: "Have a question? Feel free to ask us anything.",
		contactFormSubheader: "We will get back to you as soon as possible.",
		contactFormSubmitted: "Your question has been successfully submitted.",
		subject: "Subject",
		errorSubmitting: "Error submitting form",
		alreadySubmitted: "Form already submitted",

		submissionDisclaimer: {
			sec0: "Please keep in mind that this means your application was successfully submitted to ",
			sec1: "our",
			sec2: " system, ",
			sec3: "not",
			sec4: " the ",
			sec5: "Spanish Administration.",
			sec6: " Our system submits applications every few hours to the Spanish Administration. At any time, you can see the status of your application under the tab ",
			sec7: "My Cases.",
		},
		toolTips: {
			bgchksP1: "The immigration regulation exempts certain people from having to provide a criminal background check, if they fall squarely into one of the two categories listed below.",
			bgchksP2: "If you fall into one of the two categories and wish to claim exemption, you may do so by selecting the appropriate category. ",
			bgchksBold1: "Note that you may be required to provide evidence that you fall into that category!! ",
			bgchksEnd: "If you do not meet all of the conditions of either category, do not claim an exemption.",
		}
	},

	es: {
//General categories
		generalCategories: {
			studyInSpain: "Estudiar en España",
			liveInSpain: "Vivir en España",
			becomeSpanish: "Hacerme español/a",
		},

		generalCategoriesDescription: {
			auxToResidence: "Pasar de un permiso de estancia como 'auxiliar de conversación' a un permiso de residencia.",
			studyInSpain: "Obtener un permiso de estancia para estudiar en España. Este es un permiso de estancia, no de residencia, y el tiempo que se esté en España con él no cuenta hacia la nacionalidad.",
			liveInSpain: "Obtener residencia española. El tiempo que se pase como residente legal en España sí cuenta hacia la nacionalidad.",
			becomeSpanish: "Únase al club y conviértase en ciudadano español.",
		},

//Casetypes
//Translate these. We don't offer them all now but we will so just translate, PLEASE

		caseTypes: {
			auxToResidence: "Auxiliar a residencia",
			studentStay: "Estancia para estudios",
			studentStayRenewal: "Prórroga de la estancia para estudios",
			studentStayWork: "Trabaje mientras se está en España como estudiante",
			studentRenewalAndWork: "Prórroga de estancia por estudios y trabajo",
			arraigoSocial: "Arraigo social",
			arraigoSociolaboral: "Arraigo sociolaboral",
			arraigoSegundaOportunidad: "Arraigo de segunda oportunidad",
			arraigoSocioformativo: "Arraigo socioformativo",
			arraigoFamiliar: "Arraigo familiar",
			nonLucrativeResidencyRenewal: "Renovación de residencia no lucrativa",
			spanishCitizenship: "Nacionalidad española",
		},
		
		caseTypeDescriptions: {
			studentStay: "Estudiar en España. Este permiso de estancia puede o no permitirle trabajar.",
			studentStayRenewal: "Prorrogar un permiso de estancia por estudios. Este permiso de estancia puede o no permitirle trabajar.",
			studentStayWork: "Estudiar en España y solicitar permiso para trabajar a tiempo parcial.",
			studentRenewalAndWork: "Prorrogar un permiso de estancia por estudios y solicitar permiso para trabajar a tiempo parcial.",
			arraigoSocial: "Obtener residencia en España por tener raíces sociales en el país.",
			arraigoSociolaboral: "Obtener residencia por tener raíces laborales en el país",
			arraigoSegundaOportunidad: "Obtener residencia tras haberla perdido en los últimos dos años",
			arraigoSocioformativo: "Obtener residencia por arraigo basado en estudios con la posibilidad de estudiar y trabajar a tiempo parcial",
//Error. I'm not sure if I introduced the error or if in original. "arragoFamiliar" should be "arraigoFamiliar", as it is elsewhere.
			arragoFamiliar: "Obtener residencia por tener vínculos familiares en el país",
			nonLucrativeResidencyRenewal: "Renovar una residencia no lucrativa (también conocida como visado no lucrativo).",
			spanishCitizenship: "Unirme al club y convertirme en español/a",
		},


//Coming soon
		continentalisExpress: 'Continentalis Express',
		comingSoon: 'Próximamente',
		appDescription: 'Una aplicación para presentar trámites por cuenta propia ante la Administración española sin necesidad de certificados, cl@ve ni quebraderos de cabeza.',
//User
		isoLang: 'es-ES',
		settings: "Configuración",
		logout: "Cerrar sesión",
		welcome: "Bienvenido",
		legal: "Aviso legal",
		legalDocs: "Documentos legales",
		privacyPolicy: "Política de privacidad",
		legalNotice: "Aviso legal",
		termsofServiceGeneral: "Términos generales de servicio",
		profile: "Perfil",
		documents: "Portafolio",
		close: "Cerrar",
		open: "Abrir",
		other: "Otros",
		profileAndCases: "Perfil y casos",
		notifications: "Notificaciones",

		openCases: 'Casos abiertos',
		presentedCases: 'Casos presentados',
		resolvedCases: 'Casos resueltos',
		myCases: 'Mis casos',
		newCase: 'Nuevo caso',
		back: "Atrás",
		help: 'Ayuda',
		iWant: "Quiero...",
		immigrationCitizenship: "Extranjería y nacionalidad",
		auxToResidence: "Auxiliar a residencia",
		stayInSpain: "Estudiar en España",
		stayAndWorkInSpain: "Estudiar y trabajar en España",
		residencyInSpain: "Vivir en España",
		workInSpain: "Vivir y trabajar en España",
		becomeSpanish: "Hacerme español/a",
		regularization2026: "Regularización 2026",
		education: "Declaración de equivalencia educativa",
		homologateSecondaryStudies: "Título de estudios secundarios",
		homolagateBachelors: "Título de grado",
		homologateMasters: "Título de máster",

//Student Stay Options
		studentStayOptions: "Opciones de estancia para estudiantes",
		studentStay: "Permiso de estancia para estudiantes",
		studentStayRenewal: "Prórroga de estancia para estudiantes",
		moreThanSixMonths: "Obligatorio si la estancia es de seis meses o más",
		moreThanSixMonthsText: "¿Desea solicitar un permiso de estancia de seis meses o más?",

//Residency Options
		residencyOptions: "Opciones de residencia",
		arraigoSocial: "Arraigo social",
		arraigoSociolaboral: "Arraigo sociolaboral",
		arraigoSegundaOportunidad: "Arraigo de segunda oportunidad",
		arraigoSocioformativo: "Arraigo socioformativo",
		arraigoFamiliar: "Arraigo familiar",
		nonLucrative: "Residencia no lucrativa",
		nonLucrativeRenewal: "Renovación de residencia no lucrativa",

//Work Residency Options
		digitalNomadResidency: "Residencia para nómadas digitales (teletrabajadores de carácter internacional)",

//Aux to Residence
//Skip for Aux->Residence
		businessPlan: "Plan de negocio",
		qualification: "Prueba de cualificación profesional",
		proofOfInvestment: "Prueba de inversión suficiente",
		jobCreation: "Declaración sobre la creación de empleo",
		fee: "Tasa administrativa (tasa 790-052)",

		finalizaciónAux: "He completado mis actividades como Auxiliar de Conversación y dispongo de un certificado que lo acredita.",
		certificadoFinalizaciónAux: "Certificado de finalización",
		declaraciónFinalización: "Declaración responsable de finalización",
		
		licensure: "Sé o me han informado de que mi actividad empresarial REQUIERE una licencia.",
		license: 'Licencia',
		typeOfLicense: "Por favor, indique las autorizaciones, licencias y requisitos necesarios. No podemos ayudarle con esto. Se recomienda encarecidamente consultar con un abogado especializado en inmigración si no está seguro al respecto.",
		numJobs: "Número de puestos de trabajo",
		employment: "Mi actividad empresarial prevista generará empleo directamente, aparte del mío propio",
		numJobsDec: "Número de puestos de trabajo aparte del suyo propio",

		empresa: "Empresa",
		otraEntidad: "Desarrollaré mi actividad como autónomo a través de una empresa u otra entidad",
		formulariosEmpresa: "Estatutos de constitución de la empresa o entidad",

		exColony: "Exención de la tasa administrativa",
		exColonyCitizen: "Por favor, facilite un documento que acredite que pertenece a una de estas categorías: filipino, ecuatoguineano, sefardí, hijo o nieto de un español o de un extranjero nacido en España",
		exColonyProve: "Documentos que acrediten la ciudadanía iberoamericana o filipina",
		notExColonyFee: "Tasa administrativa para el trabajo por cuenta propia (790-062)",

		documentosRecomendados: "Documentos recomendados",
		listaDocumentosRecomendados: "Informe de viabilidad expedido por ATA, UPTA, CIAE, OPA o UATAE",


//Intial Stay
		pleaseDragNDrop: "Por favor, arrastre y suelte los documentos requeridos: ",
//Error.? Is dragNDrop supposed to be a comment?
//		dragNDrop: "Arrastrar y soltar o hacer clic",
		dragNDrop: "Cargue el documento buscando archivos o arrastrándolo y soltándolo aquí.",
		fullPassport: "Scan completo del pasaporte",
		proofInsurance: "Acreditación de seguro médico",
		proofHealth: "Acreditación de buena salud",
		backgroundCheck: "Certificado de antecedentes penales",
		financialMeans: "Acreditación de medios económicos",
		proofAdmission: "Acreditación de admisión",
		proofLegalStatus: "Acreditación de situación legal",
		poa: "Poder de representación",

		criminalAndHealth: "Antecedentes penales y salud",
		requiredIfNotPrev: "Estos documentos solo son necesarios si no ha tenido que presentarlos anteriormente para sus permisos de estancia o prórrogas anteriores.",

//Student Stay Extension
		proofPrevProgramCompletion: "Justificante de finalización del programa anterior",
		proofProgramContinuation: "Justificante de continuación del programa",
		ifNotPresentedBefore: "Si no se ha presentado para el permiso de estancia inicial",


//Arraigos
        proofTwoYears: "Prueba de residencia continua durante los 2 años inmediatamente anteriores a la solicitud",

//Arraigo social
//Omitir para Arraigo

		familyThirdPartyNational: "Mi cónyuge, pareja de hecho, hijo o progenitor es un ciudadano de un tercer país que reside legalmente en España.",	
		pruebaVínculoFamiliar: "Certificado de matrimonio, de pareja de hecho o de nacimiento que acredite el vínculo familiar",
        residenciaMiembroFamilia: "Permiso de residencia o resolución del miembro de la familia",
        pruebaRecursosEconómicosFamilia: "Prueba de recursos económicos (100 % del IPREM para el solicitante y 100 % para el miembro de la familia)",

		
//Arraigo sociolaboral
//Omitir para Arraigo
        contratoLaboral: "Contrato de trabajo condicionado a la obtención de la residencia. Por lo general, de al menos 1 año, con 20 horas semanales en total.",
        datosEmpleador: "Datos del empleador",
        direcciónEmpleador: "Dirección del lugar de trabajo",
        nombreEmpleador: "Nombre del empleador",
        tipoIDEmpleador: "Tipo de identificación del empleador",
        opcionesTipoIDEmpleador: [
            {valor: 'dni', etiqueta: "DNI"},
            {valor: 'nie', etiqueta: 'NIE'},
			{value: 'passport', label: 'Pasaporte'},
        ],
        employerID: "Identificador del empleador",
        employerEmail: "Correo electrónico del empleador",
        employerPhone: "Teléfono del empleador",
        isEmployerFirm: "¿Su empleador es una empresa o una persona física?",
		opcionesDeEmpleador: [
            {valor: true, etiqueta: "Empresa"},
            {valor: false, etiqueta: "Persona física"},
        ],
		
		nombreEmpresa: "Nombre de la empresa",
        NIFEmpresa: "NIF de la empresa",
        correoEmpresa: "Correo electrónico de la empresa",
        teléfonoEmpresa: "Teléfono de la empresa",


		companyRepName: "Nombre del representante de la empresa",
        companyRepIDType: "Tipo de identificación del representante de la empresa",
        companyRepIDTypeOptions: [
            {value: 'dni', label: "DNI"},
            {value: 'nie', label: "NIE"},
			{value: 'passport', label: 'Pasaporte'},
        ],
        companyRepID: "Identificación del representante de la empresa",
        companyRepTitle: "Cargo del representante de la empresa",


//Arraigo socioformativo
//Omitir, para arraigo

		matriculación: "Certificado de matriculación",
        cartaAdmisión: "Copia de la admisión o carta de admisión",
        yaEstudiandoTítulo: "Ya está cursando estudios",
        yaEstudiando: "¿Ya está cursando o matriculado en su curso?",
		admission: "Admisión o carta de admisión",
        schoolData: "Datos del centro y del curso",
        schoolAddress:     "Dirección del centro",
        schoolName: "Nombre del centro",
        schoolNIF: "NIF del centro",
        schoolPhone: "Número de teléfono móvil del centro (debe comenzar por 6 o 7)",
        schoolEmail: "Correo electrónico del centro",
        courseName: "Nombre del curso",
        courseCode: "Código del curso",
        courseStartDate: "Fecha de inicio del curso",
        courseEndDate: "Fecha de finalización del curso",
        courseType: "Tipo de curso",
		courseDuration: "Duración del curso (horas)",
        courseTypeOptions: [
            {value: "Educación secundaria postobligatoria", label: "Educación secundaria postobligatoria"},
            {value: "Obtención de certificado profesional", label: "Certificado profesional"},
			{value: "Oferta presencial correspondiente a las enseñanzas obligatorias dentro de la educación de personas adultas", label: "Oferta formativa presencial correspondiente a la educación obligatoria en el ámbito de la educación de adultos"},
            {value: "Formación promovida por los Servicios Públicos de Empleo en España", label: "Formación promovida por los Servicios Públicos de Empleo en España"},
        ],
		classMode: "Modo de clase",
        classModeOptions: [
            {value: "Presencial", label: "Presencial"},
            {value: "A distancia", label: "A distancia/en línea"},
            {value: "Mixta", label: "Mixta"},
        ],



//Arraigo familiar
        guardian: "¿Es usted el padre/tutor de un menor que es ciudadano de la UE/EEE?",
		pruebaCiudadaníaMenor: "Prueba de la ciudadanía de la UE/EEE del menor",
        pruebaCustodiaMenor: "Prueba de que tiene la custodia del menor",
        pruebaResidenciaConMenor: "Prueba de que reside con el menor",
        pruebaCumplimientoObligacionesTutor: "Prueba de que cumple con sus obligaciones parentales o de tutela",

		cuidador: "¿Es usted el cuidador de una persona con discapacidad que es ciudadana de la UE/EEE?",
        pruebaCiudadaníaPersonaDiscapacitada: "Prueba de la ciudadanía de la persona con discapacidad",
        pruebaDiscapacidadPersonaDiscapacitada: "Prueba de la discapacidad de la persona con discapacidad",
        pruebaCuidadorLegal: "Prueba de que presta apoyo en calidad de cuidador legal",
		pruebaPersonaDiscapacitadaBajoCuidado: "Prueba de que la persona con discapacidad está bajo su cuidado",
        pruebaMiembrosFamilia: "Prueba de que la persona con discapacidad es un miembro de su familia",
        exenciónTutorCuidador: "Debe ser padre/madre, tutor o cuidador de un ciudadano de la UE/EEE por motivos familiares. Quizás esté pensando en el arraigo social.",

//Declaraciones responsables (arraigo)
        responsibleDeclarationsStr: "Declaraciones responsables",
        publicSafety: "Seguridad pública",
        criminalRecordPresentationExemption: "Exención de la presentación del certificado de antecedentes penales",
        mayNotApply: "Esta sección es opcional y puede que no se aplique a su caso. Lea atentamente.",
        declaracionesResponsables: {
            sinProtecciónInternacional: "Me encuentro en España, actualmente no soy solicitante de protección internacional/asilo y no solicitaré protección internacional/asilo durante mi procedimiento de arraigo.",
            requisitoTiempoArraigo: "He permanecido en España de forma ininterrumpida durante al menos los dos últimos años anteriores a la apertura de este procedimiento",
			noThreat: "No soy guay y, por lo tanto, no represento una amenaza para el orden público, la seguridad o la salud (en serio, ¿qué coño está haciendo con su vida?)",
            noCriminalRecord: "No tengo antecedentes penales en España ni en los países en los que he residido durante los últimos cinco años anteriores a la apertura de este procedimiento.",
			previousNotDeniedForPubSafety: "He tenido un permiso de residencia válido en los últimos dos años, que NO fuera un permiso de residencia por circunstancias excepcionales (p. ej., arraigo), y que no se haya renovado por motivos distintos a los de orden público, seguridad o salud",
			previousDeniedForPublicSafety: "He tenido un permiso de residencia válido en los últimos dos años, que NO sea un permiso de residencia por circunstancias excepcionales (p. ej., arraigo), y que no se haya renovado por motivos de orden público, seguridad o salud, pero dichos motivos HAN SIDO ANULADOS o REVOCADOS.",
			inSpain5Years: "Estoy exento de presentar un certificado de antecedentes penales extranjero, ya que no he salido de España en los últimos 5 años previos a este procedimiento",
            notInSpain5Years: "He presentado un certificado de antecedentes penales en un procedimiento anterior en los últimos 5 años y no he salido de España desde entonces",
			iNeedBgchk: "Ninguna de las afirmaciones anteriores es cierta y necesito presentar un certificado de antecedentes penales (arrastre y suelte a continuación)",
            poaLater: "Entiendo que es posible que se me exija obtener un poder notarial más adelante para mi trámite",
        },


//Nacionalidad española

		spanishCitizenship: "Nacionalidad española",

//Basic info
		required: 'Obligatorio',
		invalid: 'No válido',
		requiredIfHave: 'Obligatorio si dispone de uno',
		requiredIfYouLive: 'Obligatorio si reside en uno',
		basicInfo: 'Información básica',
		firstName: 'Nombre',
		lastName: 'Apellido',
		middleName: 'Segundo nombre',
		secondLastName: 'Segundo apellido',
		passportNumber: 'Número de pasaporte',
		NIE: 'NIE',
		gender: 'Género legal',
		dateOfBirth: 'Fecha de nacimiento',
		countryOfBirth: 'País de nacimiento',
		placeOfBirtho: "Lugar de nacimiento (ciudad o municipio)",
		civilStatus: "Estado civil",
		fathersFullName: "Nombre y apellidos del padre",
		mothersFullName: "Nombre y apellidos de la madre",
		countriesOfCitizenship: "País(es) de nacionalidad (incluya todos!)",

		legalGenderOptions: [
			{value: 'HOMBRE', label: 'Masculino'},
			{value: 'MUJER', label: 'Femenino'},
			{value: 'INDEFINIDO', label: 'Otro'},
		],

//Civil status options
		civilStatusOptions: [
			{value: 'SOLTERO/A', label:'Soltero/a (incluida la unión de hecho)'},
			{value: 'CASADO/A', label: 'Casado/a'},
			{value: 'SEPARADO/A', label: 'Separado/a'},
			{value: 'DIVORCIADO/A', label: 'Divorciado/a'},
			{value: 'UNIóN DE HECHO', label: 'Unión de hecho inscrita (pareja de hecho)'},
//Error.? Should this (below) be commented?
//             {value: 'DESCONOCIDO', label: 'Desconocido'},
        ],

		yesNoOptions: [
            {value: false, label: 'No'},
            {value: true, label: 'Sí'},
        ],

//Address
	//Skip this obj, not translatable

	typeOfStreetOptions: [
		{ value: "ACCESO", label: "Acceso" },
		{ value: "ACEQUIA", label: "Acequia" },
		{ value: "ALAMEDA", label: "Alameda" },
		{ value: "ALBEREDA", label: "Albereda" },
		{ value: "ALDEA", label: "Aldea" },
		{ value: "ALTO", label: "Alto" },
		{ value: "ANGOSTA", label: "Angosta" },
		{ value: "ARROYO", label: "Arroyo" },
		{ value: "ATAJILLO", label: "Atajillo" },
		{ value: "ATAJO", label: "Atajo" },
		{ value: "AVENIDA", label: "Avenida" },
		{ value: "BAJADA", label: "Bajada" },
		{ value: "BARRACAS", label: "Barracas" },
		{ value: "BARRIADA", label: "Barriada" },
		{ value: "BARRIO", label: "Barrio" },
		{ value: "BLOQUE", label: "Bloque" },
		{ value: "CALA", label: "Cala" },
		{ value: "CALLE", label: "Calle" },
		{ value: "CALLEJA", label: "Calleja" },
		{ value: "CALLEJON", label: "Callejón" },
		{ value: "CALLEJUELA", label: "Callejuela" },
		{ value: "CALZADA", label: "Calzada" },
		{ value: "CAMINO", label: "Camino" },
		{ value: "CARRERA", label: "Carrera" },
		{ value: "CARRETERA", label: "Carretera" },
		{ value: "CARRIL", label: "Carril" },
		{ value: "CASA", label: "Casa" },
		{ value: "CASERIO", label: "Caserío" },
		{ value: "COBERTIZO", label: "Cobertizo" },
		{ value: "COLONIA", label: "Colonia" },
		{ value: "CORRALILLO", label: "Corralillo" },
		{ value: "CORREDOR", label: "Corredor" },
		{ value: "CORTIJO", label: "Cortijo" },
		{ value: "COSO", label: "Coso" },
		{ value: "COSTA", label: "Costa" },
		{ value: "COSTANILLA", label: "Costanilla" },
		{ value: "CRUCE", label: "Cruce" },
		{ value: "CUESTA", label: "Cuesta" },
		{ value: "DEHESA", label: "Dehesa" },
		{ value: "DESCONOCIDO", label: "Desconocido" },
		{ value: "DISEMINADO", label: "Diseminado" },
		{ value: "EDIFICIO", label: "Edificio" },
		{ value: "ENSENADA", label: "Ensenada" },
		{ value: "ESCALA", label: "Escala" },
		{ value: "ESCALERA", label: "Escalera" },
		{ value: "ESCALINATA", label: "Escalinata" },
		{ value: "FINCA", label: "Finca" },
		{ value: "GALERIA", label: "Galería" },
		{ value: "GLORIETA", label: "Glorieta" },
		{ value: "GRAN VIA", label: "Gran vía" },
		{ value: "GRUPO", label: "Grupo" },
		{ value: "LUGAR", label: "Lugar" },
		{ value: "MANZANA", label: "Manzana" },
		{ value: "MONTE", label: "Monte" },
		{ value: "PARAJE", label: "Paraje" },
		{ value: "PARQUE", label: "Parque" },
		{ value: "PARTIDA", label: "Partida" },
		{ value: "PASADIZO", label: "Pasadizo" },
		{ value: "PASAJE", label: "Pasaje" },
		{ value: "PASARELA", label: "Pasarela" },
		{ value: "PASEO", label: "Paseo" },
		{ value: "PASILLO", label: "Pasillo" },
		{ value: "PASO", label: "Paso" },
		{ value: "PLAYA", label: "Playa" },
		{ value: "PLAZA", label: "Plaza" },
		{ value: "PLAZOLETA", label: "Plazoleta" },
		{ value: "PLAZUELA", label: "Plazuela" },
		{ value: "POBLADO", label: "Poblado" },
		{ value: "POLIGONO", label: "Polígono" },
		{ value: "PONTON", label: "Pontón" },
		{ value: "PORTICO", label: "Pórtico" },
		{ value: "POSTIGO", label: "Postigo" },
		{ value: "PUENTE", label: "Puente" },
		{ value: "PUERTO", label: "Puerto" },
		{ value: "RAMBLA", label: "Rambla" },
		{ value: "REGATO", label: "Regato" },
		{ value: "RIERA", label: "Riera" },
		{ value: "RINCONADA", label: "Rinconada" },
		{ value: "RONDA", label: "Ronda" },
		{ value: "SENDA", label: "Senda" },
		{ value: "SENDERO", label: "Sendero" },
		{ value: "SEQUIA", label: "Sequía" },
		{ value: "SOLANA", label: "Solana" },
		{ value: "SUBIDA", label: "Subida" },
		{ value: "TORRENTE", label: "Torrente" },
		{ value: "TRAVESIA", label: "Travesía" },
		{ value: "TUNEL", label: "Túnel" },
		{ value: "URBANIZACION", label: "Urbanización" },
		{ value: "VALLE", label: "Valle" },
		{ value: "VECINDARIO", label: "Vecindario" },
		{ value: "VEREDA", label: "Vereda" },
		{ value: "VIA", label: "Vía" },
		{ value: "VIA ALTERNATIVA", label: "Vía alternativa" },
		{ value: "VIA DIRECTA", label: "Vía directa" },
		{ value: "VIAL", label: "Vial" },
		{ value: "ZOKO", label: "Zoko" },
		{ value: "ZONA", label: "Zona" },
		{ value: "ZULO", label: "Zulo" }
	],

		physicalAddress: "Current Physical Address",
		typeOfStreet: 'Type of Street',
		street: 'Street',
		streetNumber: 'Number',
		apt: 'Apartment/Unit Number',
		postalCode: 'Postal Code',
		city: 'City/Town',
		province: 'State or Province',
		country: 'Country',
		
		addressFact: "Fun address fact for you Americans: the zip/postal code here in Spain <i>begins</i> the final line of the address:\nJane Fulanita\nC/ España, 123, 2A,\n1111, Madrid",

//Disclaimers
		smallChildren: "Tengo hijos/as que viven conmigo en España y que están obligados/as a estar matriculados en la escuela.",
		children: "Hijos",
		childSchoolEnrollment: "Acreditación de la matriculación escolar de los hijos/as",
		childCourseCompletion: "Acreditación de la finalización de los estudios de los hijos/as",

//Documentos adicionales
		additionalDocs: "Documentos adicionales",
		anyAdditionalDocs: "Cualquier documento adicional que desee proporcionar (por ejemplo, una copia de un pasaporte caducado recientemente, prueba de un cambio de nombre reciente, etc.).",
		addDocument: "Añadir documento",

//Legal Status

		iHaveAnEntryStamp: "TENGO un sello de entrada en España en mi pasaporte",
		declarationOfEntry: "Una declaración de entrada realizada en los 3 días siguientes a la entrada",
		otherEntryDoc: "Otro documento de entrada (p. ej., billete de embarque)",

//Submit
		submit: 'Enviar',
		saveDraft: 'Guardar borrador',
		draftSaved: "Borrador guardado correctamente",
		draftSavedError: "Borrador no guardado. Error.",
		popupTitleSubmit: "La siguiente acción enviará su solicitud",
		popupMessageSubmit: "Asegúrese de que la información es correcta y de que ha incluido todos los documentos necesarios antes de enviar su solicitud.",
		popupMessagePartialSubmission: "Si no dispone de todos los documentos necesarios, podemos enviar la solicitud de todos modos, pero deberá proporcionar dichos documentos lo antes posible o cuando la administración española se los requiera.",
		submitApplication: "Enviar mi solicitud",
		goBack: "Volver",
		goHome: "Volver a la página de inicio",
		submissionSuccessful: "¡Solicitud enviada con éxito!",
		submissionCaveat: "Tenga en cuenta que esto significa que su solicitud se ha enviado correctamente a <b>NUESTRO</b> sistema, no a la Administración española. Nuestro sistema envía las solicitudes a la Administración española cada pocas horas. En cualquier momento, puede consultar el estado de su solicitud en la pestaña 'Mis casos'.",
        invalidForm: "Cumplimente todos los campos obligatorios",

//Signature pad
		signaturePad: "Área de firma",
		signatureForm: "La firma debe ser similar a la que figura en su TIE o pasaporte.",
		savedSignature: "Firma guardada",
		saveErrorSignature: "Error al guardar la firma",

//Documents
		loadingDocs: "Cargando documentos...",
		uploadedDocs: "Documentos anteriormente cargados",
		nuevoDoc: "Subir nuevo documento",
		upload: "Subir",
		chooseFile: "Elegir archivo",
		chooseDocument: "Elegir documento",
		requiredDocs: "Documentos obligatorios",
		mayBeRequired: "Documentos que pueden ser necesarios más adelante",
		smartUpload: "Hemos rellenado previamente sus documentos con documentos existentes del mismo tipo si se han subido recientemente. ¡Por favor, asegúrese de que sean correctos!",
		smartAutoFill: "Rellenamos automáticamente muchos campos a partir de casos anteriores o de los datos que nos proporcionó al registrarse. ¡Por favor, asegúrese de que no hayan cambiado!",
		message: "Mensaje",
		optionalMessage: "Mensaje opcional",
		oneOrBoth: "Por favor, facilite uno o ambos de los siguientes",
		oneOf: "Por favor, facilite uno de los siguientes",
		informeArraigo: "Informe de arraigo",
		proofEconomicMeans: "Justificante de medios económicos (100 % del IPREM)",

//Legal Notice

//Cases

		thisCase: "Caso",
		noResolvedCases: "Aún no tiene casos resueltos que mostrar.",

//Caseconfirm
		confirmNewCase: "¿Está seguro de que desea abrir un caso nuevo?",
		existingCaseType: "Ya tiene un caso de este tipo abierto. ¿Está seguro de que desea abrir otro? Una vez que un caso está abierto y enviado a la administración, no se puede cerrar hasta que se resuelva.",
		caseLimit: "El límite es de 5 casos de cada tipo simultáneamente.",
		poshYes: "Sí, forma parte de mi plan maestro",
		poshNo: "No, gracias",

//No cases available
		noCasesAvailable: "No tiene ningún caso nuevo disponible",
		buyMoreCases: "No dude en comprar otro caso",
		here: "aquí",
		backToHome: "Atrás",
		availableCases: "Casos disponibles",

//Notifications
		activeNotifications: "Notificaciones activas",
		receivedOn: "Recibido el",

//Profile
		personalInfo: 'Información personal',
		email: 'Correo electrónico',
		name: 'Nombre',
		address: 'Dirección',
		nationalities: 'Nacionalidades',
		changeImmutableInfo: "Entendemos que algunos de estos datos, que suelen ser inmutables, como el nombre o el género, pueden cambiar. También entendemos que todos ustedes son unos hobbits astutos y pueden compartir cuentas. Si necesita modificar estos datos, simplemente",
		contactUs: "CONTÁCTENOS",
		edit: "Editar",
		noNeedToEdit: "Siéntase libre de modificar lo que desee. Sin embargo, por lo general no debería ser necesario. A medida que rellene su expediente, estos campos se completarán automáticamente.",


//Login
		password: 'Contraseña',
		confirmPassword: 'Confirme su contraseña',
		login: 'Iniciar sesión',
		loginMessage: '¡Bienvenido a Continentalis Express!',
		noAccount: "¿No tiene una cuenta?",
		signUp: 'Dese de alta',
		passwordsDontMatch: "Las contraseñas no coinciden.",
		passwordTooShort: "La contraseña debe tener al menos 8 caracteres.",
		noPassword: "No ha introducido una contraseña.",
		wrongCredentials: "Correo electrónico o contraseña incorrectas",
		enterValidEmail: "Introduzca un correo electrónico válido.",
		forgotPassword: "¿Ha olvidado su contraseña?",
		passwordRecovery: "Restablecer contraseña",
		sendResetEmail: "Enviar correo electrónico de restablecimiento",
		resetEmailSent: "Correo electrónico de restablecimiento de contraseña enviado correctamente.",
		failedAccountCreate: "Error. No se ha podido crear la cuenta.",

//Help
		frequentlyAskedQuestions: 'Preguntas frecuentes',
		faq: "Preguntas frecuentes",
//Contact
		contact: "Contacto",
		contactForm: "¿Tiene alguna pregunta? No dude en preguntarnos.",
		contactFormSubheader: "Nos pondremos en contacto con usted lo antes posible.",
		contactFormSubmitted: "Su pregunta se ha enviado correctamente.",
		subject: "Asunto",
		errorSubmitting: "Error al enviar el formulario",
		alreadySubmitted: "Formulario ya enviado",

		submissionDisclaimer: {
			sec0: "Por favor, tenga en cuenta que esto significa que su solicitud se ha enviado correctamente a ",
			sec1: "nuestro",
			sec2: " sistema",
			sec3: "no",
			sec4: " a la ",
			sec5: "Administración española",
			sec6: " Nuestro sistema envía las solicitudes cada pocas horas a la Administración española. En cualquier momento, puede consultar el estado de su solicitud en la pestaña ",
			sec7: "Mis casos",
		},
		toolTips: {
			bgchksP1: "La normativa de inmigración exime a determinadas personas de la obligación de presentar un certificado de antecedentes penales, si encajan claramente en una de las dos categorías que se enumeran a continuación",
			bgchksP2: "Si usted cumple con los requisitos de una de las dos categorías y desea solicitar la exención, puede hacerlo seleccionando la categoría correspondiente. ",
			bgchksBold1: "Tenga en cuenta que es posible que se le solicite que aporte pruebas de que entra en esa categoría!! ",
			bgchksEnd: "Si no cumple todas las condiciones de ninguna de las dos categorías, no solicite la exención.",
		}

	}
}

export default strs
